import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./i18n";
import Navbar from "./components/Navbar";
import LoginModal from "./components/LoginModal";
import InstallPWA from "./components/InstallPWA";
import FAQChat from "./components/FAQChat";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import BookingPage from "./pages/BookingPage";
import RegisterProviderPage from "./pages/RegisterProviderPage";
import DashboardPage from "./pages/DashboardPage";
import ClientDashboardPage from "./pages/ClientDashboardPage";
import MessagesPage from "./pages/MessagesPage";
import AdminPage from "./pages/AdminPage";

function App() {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar
            onLoginClick={() => setLoginOpen(true)}
            transparent={false}
          />
          <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
          <InstallPWA />
          <FAQChat />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/booking/:id" element={<BookingPage />} />
            <Route path="/devenir-prestataire" element={<RegisterProviderPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/mes-reservations" element={<ClientDashboardPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
